// messagePacks.js
'use strict';
import { fromJS } from 'immutable';
import {
  MERGE_MESSAGE_PACKS,
  // -- PLOP_PREPEND_REDUCER_ACTION_TYPE --
  LOGOUT,
} from '../ActionTypes.js';

export const defaultState = fromJS({});

/**
 * Message packs.
 * @module reducer/messagePacks
 */
const messagePacks = (state = defaultState, action) => {
  switch (action.type) {
    case MERGE_MESSAGE_PACKS:
      return _MERGE_MESSAGE_PACKS(action.payload)(state);
    // -- PLOP_PREPEND_REDUCER_SWITCH_CASE --
    case LOGOUT:
      return _LOGOUT(action.payload)(state);
    default:
      return state;
  }
};

/**
 * Merge message packs
 * @kind reducer/actionType
 * @name MERGE_MESSAGE_PACKS
 * @param {object} {messagePacks} - message packs using id as keys
 * @return {Immutable.Map} New state
 */
const _MERGE_MESSAGE_PACKS =
  ({ messagePacks }) =>
  state => {
    return state.mergeDeep(messagePacks);
  };

// -- PLOP_PREPEND_REDUCER_ACTION_HANDLER --

/**
 * Logout
 * @kind reducer/actionType
 * @name LOGOUT
 * @return {Immutable.Map} New state
 */
const _LOGOUT = () => () => {
  return defaultState;
};

export default messagePacks;
